import React from "react";
import { ToastContainer } from "react-toastify";
import ViewBrand from "../../components/ProductManager/Brand/ViewBrand";

export const ViewBrandPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewBrand />
        </div>
      </div>
    </div>
  );
};
